var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var UpdateEvents;
(function (UpdateEvents) {
    UpdateEvents["lastVisited"] = "lastVisited";
    UpdateEvents["favoritePages"] = "favoritePages";
    UpdateEvents["visitedBundles"] = "visitedBundles";
})(UpdateEvents || (UpdateEvents = {}));
var chromeState = function () {
    var state = {
        lastVisitedPages: [],
        favoritePages: [],
        visitedBundles: {},
        initialized: false,
    };
    var subscriptions = {
        lastVisited: new Map(),
        favoritePages: new Map(),
        visitedBundles: new Map(),
    };
    function subscribe(event, onUpdate) {
        var id = Symbol(event);
        subscriptions[event].set(id, { onUpdate: onUpdate });
        onUpdate();
        return id;
    }
    function unsubscribe(id, event) {
        if (subscriptions[event].has(id)) {
            subscriptions[event].delete(id);
        }
        else {
            console.error('Trying to unsubscribe non existing client!');
        }
    }
    function update(event, attributes) {
        state = __assign(__assign({}, state), attributes);
        var updateSubscriptions = subscriptions[event];
        if (updateSubscriptions.size === 0) {
            return;
        }
        Array.from(updateSubscriptions.values()).forEach(function (subscriber) {
            subscriber.onUpdate();
        });
    }
    function setLastVisited(pages) {
        update(UpdateEvents.lastVisited, { lastVisitedPages: pages });
    }
    function setFavoritePages(pages) {
        update(UpdateEvents.favoritePages, { favoritePages: pages });
    }
    function setVisitedBundles(visitedBundles) {
        update(UpdateEvents.visitedBundles, { visitedBundles: visitedBundles });
    }
    function getState() {
        return state;
    }
    function setIdentity(_a) {
        var lastVisitedPages = _a.lastVisitedPages, userIdentity = __rest(_a, ["lastVisitedPages"]);
        state = __assign(__assign(__assign({}, state), userIdentity), { initialized: true });
        Object.values(subscriptions)
            .flat()
            .forEach(function (event) {
            Array.from(event.values()).forEach(function (sub) {
                sub.onUpdate();
            });
        });
    }
    return {
        getState: getState,
        setLastVisited: setLastVisited,
        setIdentity: setIdentity,
        setFavoritePages: setFavoritePages,
        setVisitedBundles: setVisitedBundles,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        update: update,
    };
};
export default chromeState;
//# sourceMappingURL=chromeState.js.map